<template>
<header data-component="PageHeader.vue" class="top-0 right-0 left-0 z-64 h-16 sticky shadow-md px-5 | page-header" :class="{ 'is-static': ScreenSize > 1, 'bg-white': (ScreenSize < 1 || !HideBg)}">
	<div class="flex items-center py-5" :class="WrapperClasses">
		<a v-if="Logo && LogoLeft" :href="LogoHref" class="svg svg-logotype-oferteo">Oferteo.pl</a>

		<MenuNavbar
			v-if="Burger && ScreenSize <= 1"
			class="mr-2"
			:burger="true"
		/>

		<button v-else-if="Back && (ScreenSize <= 1 || BackOnDesktop)" data-test="page_header_arrow_left" class="global-navigation-back" @click.prevent="GoBack">
			<OIcon name="arrow-left" :size="rfpStatus ? '1' : '1.5'" class="mr-2"/>
		</button>
		<a v-if="Logo && !LogoLeft" :href="LogoHref" class="svg svg-logotype-oferteo" :class="{ 'absolute inset-x-0 mx-auto': LogoCenter }">Oferteo.pl</a>
		<div v-else-if="Title" class="ml-1" :class="TitleClasses">
			<div class="font-bold text-xs" :class="rfpStatus.class" v-html="rfpStatus.label"/>
			<div class="!p-0 font-bold text-base" :class="TitleClamp !== -1 ? `line-clamp-${TitleClamp}` : '' " @click="TitleClick" v-html="Title"/>
		</div>
		<div v-else-if="$slots.title" :class="titleSlotClass">
			<slot name="title"/>
		</div>
		<div v-if="Subtitle" class="mt-1 ml-2 font-bold text-neutral-600 text-xs" v-html="Subtitle"/>

		<hr v-if="!LogoLeft" class="flex-auto">

		<slot name="buttons">
			<template v-for="Button in Buttons">
				<button
					v-if="ScreenSize <= 1 || Button.AlwaysVisible"
					:key="Button.Action"
					class="font-bold text-xs uppercase"
					:class="Button.Class"
					@click.prevent="$emit('button-click', Button.Action, $event)"
				>
					<OIcon v-if="Button.Icon" :name="Button.Icon" :size="Button.IconSize || 1" :class="Button.IconClass"/>
					{{ Button.Label }}
				</button>
			</template>
		</slot>
		<DropdownSelect v-if="Menu.length && !ShowThreeDots" class="page-header-dropdown" :Items="Menu" :Arrowless="true" @change="OnMenuItem">
			<template #label>
				<OIcon name="more" size="1.25"/>
			</template>
		</DropdownSelect>
		<div v-if="ShowThreeDots" class="flex justify-center items-center cursor-pointer" @click="$emit('three-dots-click')">
			<OIcon name="more" size="1.25"/>
		</div>
	</div>
	<slot/>
</header>
</template>

<script lang="ts">
import DropdownSelect from './DropdownSelect.vue';
import MenuNavbar from '../navigation/MenuNavbar.vue';

// @vuese
// Komponent odpowiedzialny za wyświetlenie nagłówka okna dialogowego.
// @group Base Components
export default {
	name: 'PageHeader',
	components: {
		DropdownSelect,
		MenuNavbar,
	},
	props: {
		Title: {
			type: String,
			required: false,
		},
		TitleClasses: {
			type: String,
			default: '',
		},
		titleSlotClass: {
			type: String,
			default: '',
		},
		Subtitle: {
			type: String,
			required: false,
			default: '',
		},
		Back: {
			type: Boolean,
			default: false,
		},
		BackTo: {
			type: String,
			default: '',
		},
		BackOnDesktop: {
			type: Boolean,
			default: false,
		},
		Logo: {
			type: Boolean,
			default: false,
		},
		LogoCenter: {
			type: Boolean,
			default: false,
		},
		LogoLeft: {
			type: Boolean,
			default: false,
		},
		LogoHref: {
			type: String,
			default: '/',
		},
		Burger: {
			type: Boolean,
			default: false,
		},
		EmitInstead: {
			type: Boolean,
			default: false,
		},
		Buttons: {
			type: Array,
			default: () => [],
		},
		Menu: {
			type: Array,
			default: () => [],
		},
		rfpStatus: {
			type: Object,
			default: () => ({}),
		},
		HideBg: {
			type: Boolean,
			default: false,
		},
		WrapperClasses: {
			type: String,
			default: '',
		},
		TitleClamp: {
			type: Number,
			default: -1,
		},
		// @vuese
		// Służy do wyświetlenia trzech kropek ZAMIAST menu, emituje zdarzenie `three-dots-click` do wykonania jakiejś akcji w komponencie nadrzędnym.
		ShowThreeDots: {
			type: Boolean,
			default: false,
		},
		BackWithRouter: {
			type: Boolean,
			default: false,
		},
		RouteNameToBackTo: {
			type: String,
			default: '',
		},
	},
	emits: ['back-click', 'button-click', 'three-dots-click'],
	methods: {
		OnMenuItem(actionName:string) {
			this.$emit('button-click', actionName);
		},
		GoBack() {
			if (this.BackWithRouter) {
				if (this.RouteNameToBackTo !== '') {
					this.$router.push({ name: this.RouteNameToBackTo });
				} else {
					this.$router.back();
				}
				return;
			}
			if (this.BackTo) {
				window.location.href = this.BackTo;
				return;
			}
			if (this.EmitInstead) {
				this.$emit('back-click');
			} else {
				this.State.Back();
			}
		},
		TitleClick() {
			if (this.ScreenSize > 1) { return; }
			const el = document.querySelector('.global-navigation-submenu, .global-navigation-back') as HTMLElement;
			el?.click();
		},
	},
};
</script>

<style lang="scss">
.page-header .svg-logotype-oferteo {
	width: 100px;
	height: 28px;
}

.page-header.is-static {
	position: static;
	top: 81px;
	margin-bottom: -24px;
	box-shadow: none;
}
</style>
